{
  "name": "@safaricom-mxl/node-exception",
  "author": "Francis Masha <fkonde@safaricom.co.ke>",
  "license": "Apache-2.0",
  "version": "0.1.65",
  "type": "module",
  "main": "dist/index.js",
  "module": "dist/index.js",
  "types": "dist/index.d.ts",
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "import": "./dist/index.js"
    }
  },
  "files": [
    "dist",
    "README.md"
  ],
  "publishConfig": {
    "access": "public"
  },
  "scripts": {
    "clean": "git clean -xdf .turbo node_modules coverage dist tmp",
    "prebuild": "rimraf coverage dist tmp",
    "build": "rm -rf dist && tsup",
    "format": "biome format .",
    "lint": "biome check .",
    "typecheck": "tsc --noEmit",
    "ci:lint": "pnpm lint && pnpm tsc --noEmit",
    "dev:unit": "vitest --watch"
  },
  "dependencies": {
    "@opentelemetry/instrumentation": "^0.208.0",
    "@opentelemetry/sdk-trace-base": "^2.2.0",
    "@opentelemetry/semantic-conventions": "^1.38.0",
    "@sentry/core": "^10.27.0",
    "@sentry/types": "^10.27.0",
    "@sentry/utils": "^8.55.0",
    "json-stringify-safe": "^5.0.1"
  },
  "devDependencies": {
    "@opentelemetry/api": "^1.9.0",
    "@sentry/types-v7": "npm:@sentry/types@~10.27.0",
    "@sentry/types-v8": "npm:@sentry/types@~10.27.0",
    "@types/jest": "^30.0.0",
    "@types/json-stringify-safe": "^5.0.3",
    "@types/node": "^24.10.1",
    "jest": "^30.2.0",
    "rimraf": "^6.1.2",
    "ts-jest": "^29.4.5"
  },
  "peerDependencies": {
    "@opentelemetry/api": "^1.9.0"
  },
  "keywords": [
    "exception",
    "instrumentation",
    "nodejs",
    "opentelemetry",
    "tracing"
  ]
}
